module.exports = __webpack_public_path__ + "img/hr-green-asterisk-10.2d238bbe.png";